import { useEffect, memo } from 'react';
import { setFlag } from '@atlassian/jira-common-have-i-seen-it';

export const SEEN_IT_TTL = 20 * 365 * 24 * 60 * 60 * 1000; // ~20 years

export const SeenIt = memo(({ flag }: { flag: string }) => {
	useEffect(() => {
		setFlag(flag, SEEN_IT_TTL);
	}, [flag]);

	return null;
});
